import account from "./account.json"
import checkout from "./checkout.json"
import common from "./common.json"
import errors from "./errors.json"
import events from "./events.json"
import meta from "./meta.json"
import nav from "./nav.json"
import orders from "./orders.json"

export default { common, nav, meta, events, checkout, orders, account, errors }
